import { message } from "antd"
import { AxiosRequestConfig } from "axios"
import { HttpClient } from "~/api/HttpClient"
import { FilterSearchParams } from "~/types/types" // Import JobDetailAttributes

export const API_PREFIX_JOB_DETAIL_PATH = "/api/job-details"

export const fetchJobDetailAll = async (filters = {}) => {
  const params: FilterSearchParams = {
    pagination: {
      pageSize: "5",
    },
    populate: "*",
    filters: {},
    sort: "createdAt:desc",
    publicationState: "live",
  }
  return await HttpClient.get(`${API_PREFIX_JOB_DETAIL_PATH}`, { params })
}

export const fetchJobDetails = async (searchTerms: { [key: string]: string } = {}) => {
  const params: FilterSearchParams = {
    populate: "*",
    sort: "createdAt:desc",
    publicationState: "preview",
    filters: {},
    pagination: {
      pageSize: "5",
    },
  }
  const excludedKeys = ["current", "pageSize", "start", "limit", "total", "page"]

  Object.keys(searchTerms).forEach(key => {
    const value = searchTerms[key]

    if (key === "publicationState") {
      const convertParamStatusPost = value === "draft" || value === "all" ? "preview" : "live"
      params.publicationState = convertParamStatusPost

      if (value === "draft") {
        params.filters.publishedAt = { $null: true }
      } else {
        delete params.filters.publishedAt
      }
    } else if (!excludedKeys.includes(key)) {
      if (value) {
        params.filters[key] = { $containsi: value }
      }
    } else if (value) {
      params.pagination = {
        ...params.pagination,
        [key]: value,
      }
    }
  })

  try {
    const response = await HttpClient.get(`${API_PREFIX_JOB_DETAIL_PATH}`, { params })

    return response.data
  } catch (error: any) {
    message.error("Failed to fetch job details. Please try again.")
  }
}

export const fetchJobDetailId = async (id: number) => {
  const response = await HttpClient.get(`${API_PREFIX_JOB_DETAIL_PATH}/${id}?populate=*`)
  return response.data
}

export const deleteJobDetail = async (id: number) => {
  return await HttpClient.delete(`${API_PREFIX_JOB_DETAIL_PATH}/${id}`)
}
export const updateJobDetail = async (id: number, data: any) => {
  return await HttpClient.put(`${API_PREFIX_JOB_DETAIL_PATH}/${id}`, data)
}
export const addJobDetail = async (data: any) => {
  return await HttpClient.post(`${API_PREFIX_JOB_DETAIL_PATH}`, data)
}

export const checkSlugJobDetail = async (slug: string) => {
  const params: AxiosRequestConfig["params"] = {
    filters: {
      slug: { $eq: slug },
    },
    publicationState: "preview",
  }
  return await HttpClient.get(`${API_PREFIX_JOB_DETAIL_PATH}`, { params })
}
